/**
 * The note above the grid that says how edits are kept on a plan that is not a Draft.
 * Every plan is editable in every status; this only explains where the change goes.
 *
 *   • Locked — nothing can change until the plan's status is changed back.
 *   • Any other status — no note. Changes are listed on the Changes tab, and every saved
 *     version stays as it was.
 *
 * Which version the grid matches, and whether it has unsaved changes, is the version bar's
 * job (PlanVersionBar), in every status.
 */

import { Lock } from "lucide-react";
import type { ResourcePlanDetailView } from "@/schemas/resource-plans";

export function PlanStaffingNotice({ plan }: { plan: ResourcePlanDetailView }) {
  if (plan.status === "Locked") {
    return (
      <div
        role="note"
        className="flex items-start gap-2.5 rounded-md border border-border bg-muted px-3 py-2 text-sm text-foreground"
      >
        <Lock className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        <p>
          <span className="font-medium">This plan is Locked.</span> Change its status to make
          changes.
        </p>
      </div>
    );
  }

  // Any other status says nothing: the Changes tab already lists every edit, a banner on
  // every Proposed / Soft Committed plan was noise above the figures, and the version bar
  // says whether there are unsaved changes.
  return null;
}
